export type NativeOutgoingMessage =
  | { type: 'WEB_READY' }
  | { type: 'LOGOUT'; reason?: '401' | 'user' | string }
  | { type: 'BADGE_COUNT'; value: number };

export const sendToNative = (msg: NativeOutgoingMessage) => {
  try {
    (window as any).ReactNativeWebView?.postMessage(JSON.stringify(msg));
  } catch {}
};
